import { createCrudSlice } from '../createCrudSlice';
import quizService from '@/services/quiz.service';

const { reducer, thunks } = createCrudSlice('quiz', quizService);
export const { fetchList: fetchQuizzes, createItem: createQuiz, updateItem: updateQuiz, deleteItem: deleteQuiz } = thunks;
export default reducer;
